import { ToHTMLConverterMiddlewareManager } from './middlewareManager'
import { blockToHTML } from './contentBlockToHTML'
import { StandardToHTMLConverterMiddleware } from './middlewares/standardMiddleware'
import * as middlewares from './middlewares'
export { middlewares }

export class ToHTMLConverter {
  constructor() {
    this._manager = new ToHTMLConverterMiddlewareManager()
  }

  addDefaultMiddleware() {
    this._manager.add(new StandardToHTMLConverterMiddleware())
  }

  addMiddleware(middleware) {
    this._manager.add(middleware)
  }

  convert(block, skipWrappingTag = false) {
    return blockToHTML(block, this._manager, skipWrappingTag)
  }
}
